import { language as lan_shopifyConnection } from "./shopify";

let language = {
    ...lan_shopifyConnection,

    "A116B001": "这家店已经有人占用了。如果您是这家商店的所有者，但它没有在您的帐户中列出，请联系我们寻求帮助。",
    CONNECT_ALREADY_HAVE_ACCOUNT: "您已经有一个账户。继续使用您的",
    CONNECT_USER_EMAIL: "{{userMail}}",
    CONNECT_CONTINUE_BTN: "继续",
    CONNECT_CONNECT_TO_SHOPIFY_TEXT: "连接{{appName}}到{{storeType}}",
    CONNECT_NEW_TO_SITE_TEXT: "新建到{{appName}} ?",
    CONNECT_SIGNUP_LINK: "注册",
    CONNECT_ALREADY_HAVA_ACCOUNT_QUESTION_TEXT: "已经有账户？",
    CONNECT_SIGNIN_LINK: "登录",
    CONNECT_CONFIRM_CONNECTION_TEXT: "确认连接",
    CONNECT_CONNECT_STORE_TO_USER_TEXT: "将商店连接到{{userMail}}",
    CONNECT_SIGNIN_DIFFERENT_ACCOUNT: "用不同的账户登录",
    CONNECT_CONNECT_URL_INVALID_PARAM_TITLE:"无效的URL",
    CONNECT_CONNECT_URL_INVALID_PARAM_CONTENT:"商店连接页面 URL 中的参数缺失：{{missingField}}，请您返回{{platformName}}重试. 如果您需要进一步的帮助，请随时通过{{supportmail}}联系我们的支持团队。",
    CONNECT_CONNECT_CREATE_STORE_ISSUE_TITLE:"创建店铺异常",
    CONNECT_CONNECT_CREATE_STORE_ISSUE_CONTENT:"创建店铺时发生错误。 请再试一次。 如果问题仍然存在，请通过{{supportmail}}联系我们的支持团队。 ",
    CONNECT_CONNECT_WOO_STORE_AUTHORIZATION_ISSUE_TITLE:"店铺授权异常",
    CONNECT_CONNECT_WOO_STORE_AUTHORIZATION_ISSUE_CONTENT:"商店已成功创建，但WooCommerce授权页面有问题。 请稍后完成店铺授权。"
};

export { language }